import React, { Component, useContext } from 'react';
import { 
  BrowserRouter as Router,
  Route,
  __RouterContext
 } from 'react-router-dom';
import { Spring, useTransition, animated } from 'react-spring/renderprops';
import uuid from 'uuid';

// Components
import Header from './components/layout/Header';
import Todos from './components/Todos';
import AddTodo from './components/AddTodo';
import About from './components/pages/About';


import './App.css';


class App extends Component {
  state = {
    todos: [
      {
        id: uuid.v4(),
        title:  'Create portfolio website',
        completed: false
      },
      {
        id: uuid.v4(),
        title: 'Land killer web dev job',
        completed: false
      },
      {
        id: uuid.v4(),
        title: 'Make dinner',
        completed: false
      }
    ]
  }

  // Toggle Complete
  markComplete = (id) => {
    this.setState({ todos: this.state.todos.map(todo => {
      if(todo.id === id) {
        todo.completed = !todo.completed
      }
      return todo;
    }) });
  }

  // Delete Todo
  delTodo = (id) => {
    this.setState({ todos: [...this.state.todos.filter(todo => todo.id !== id)] });
  }
  
  // Add Todo
  AddTodo = (title) => {
    const newTodo = {
      id: uuid.v4(),
      title,
      completed: false
    }
    this.setState({ todos: [...this.state.todos, newTodo] });
  }

  render() {

    return (
      
      <Spring
        from={{ opacity: 0}}
        to={{opacity: 1}}
        config={{duration: 500}}
      >
        {props => (
          <div style={props}>
            <Router>
              <div className="App">
                <div className="container">
                  <Header />
                  <Route exact path="/" render={props => (
                    <React.Fragment>
                      <AddTodo AddTodo={this.AddTodo} />
                      <Todos todos={this.state.todos} markComplete={this.markComplete} delTodo={this.delTodo} />
                    </React.Fragment>
                  )} />
                  <Route path="/about" component={About} />
                </div>
              </div>
            </Router>
          </div>
        )}
      </Spring>
      
      );
  }
}

export default App;
